import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import RouteContainer from './RouteContainer';

/* Marco no toques esta webada, las rutas van en RouteContainer.js */

function App() {
  return (
    <div className="App">
      <Router>
        <RouteContainer />
      </Router>
    </div>
  );
}

export default App;
